

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import deepmerge from 'deepmerge'
import enUS from "./lang/en-US";
import zhCN from "./lang/zh-CN";
import iviewEn from 'view-design/dist/locale/en-US';
import iviewZh from 'view-design/dist/locale/zh-CN';
Vue.use(VueI18n);
Vue.locale = () => { };
const $t = Vue.prototype.$t;
const $tc = Vue.prototype.$tc;
const isDebug = sessionStorage.getItem('DEBUG_LANG');
Vue.prototype.$t = function (key, ...args) {
    const defaultValue = (args[0] || {}).defaultValue;
    const value = $t.call(this, key, ...args);
    if (isDebug == 1) return key;
    if (isDebug == 2) return `${key}=>${value}`;
    if (defaultValue && value === key) return defaultValue;
    return value;
}

Vue.prototype.$tc = function (key, choice, ...args) {
    const defaultValue = (args[0] || {}).defaultValue;
    const value = $tc.call(this, key, choice, ...args);
    if (isDebug == 1) return key;
    if (isDebug == 2) return `${key}=>${value}`;
    if (defaultValue && value === key) return defaultValue;
    return value;
}

export default function vueI18nInstance(locale) {
    if (!locale || typeof locale !== 'object') locale = {};
    const localeEnUS = { ...iviewEn, ...locale['en'] },
        localeZhCN = { ...iviewZh, ...locale['zh-CN'] };
    return new VueI18n({
        locale: global.LANG || process.env.VUE_APP_LANG || "zh-CN",
        messages: {
            "en": deepmerge(localeEnUS, enUS),
            "zh-CN": deepmerge(localeZhCN, zhCN),
            // "zh_CN": zhCN,
            fallbackLocale: 'zh-CN',
        },
        silentTranslationWarn: true
    })
}


